// src/json/servicesOverview.json
export const servicesOverviewgeneralContracting = {
    eyebrow: "OUR GENERAL CONTRACTING",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Full-Scale Renovations & Upgrades",
            description: "Transforming commercial and multi-unit properties with modern, functional, and energy-efficient improvements."
        },
        {
            title: "Structural Repairs & Reinforcements",
            description: "Addressing foundation issues, concrete restoration, and load-bearing structures to ensure safety and longevity."
        },
        {
            title: "Tenant Improvements & Build-Outs",
            description: "Customizing interior spaces to meet new tenant requirements, branding, and operational needs."
        },
        {
            title: "Exterior & Façade Restorations",
            description: "Revitalizing building exteriors with painting, waterproofing, masonry repairs, and high-rise envelope renewals."
        },
        {
            title: "Project Management & Coordination",
            description: "Overseeing every aspect of your project, from design and permits to execution and final inspection."
        }
    ],

    imageUrl: "/assets/imgs/services/7generalContracting/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  